/**
 * @desc 阶段处理(PR审批通过)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.TimelinessDashboardProcessPhaseRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/timelinessDashboard/processPhase`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
